import { getIsSubscriptionAlreadAddedToCart, getIsSubscriptionsActive, postAddSubscriptionToCart } from '@_api/smallbusinessset';
import { SelectModalModel } from '@_types/_custom-event';

const smallBusinessSet = {
  cartObj: {
    sku: '',
    showABN: true,
    showAssociate: true,
    licenceTerms: '',
    quantity: '1',
    productType: 'STANDARD',
    productFamily: 'STANDARD',
    currencyMnemonic: 'AUD',
  },
  addSubscriptionToCartURL: '',
  isSubscriptionAddedToCartURL: '',
  isSubscriptionActiveURL: '',
  cartURL: '',
  popUpIdItemExistsInCart: '',
  popUpIdItemExistsInLibrary: '',
  loggedIn: false,
  subscribeButtonContainer: document?.querySelector<HTMLDivElement>('.saig-o-sbs-page-subscription-details-subscribe-container'),
  init: function () {
    this.addEvent();
    this.buildCustomListener();
    this.getParsedAPIUrls();
  },
  getParsedAPIUrls: function () {
    const apiUrls = this.subscribeButtonContainer?.dataset.attr || '';
    const parsedAPIUrls = apiUrls && JSON.parse(apiUrls?.replace(/&quot;/g, '"'));
    if (parsedAPIUrls) {
      this.addSubscriptionToCartURL = parsedAPIUrls?.addSubscriptionToCart;
      this.isSubscriptionAddedToCartURL = parsedAPIUrls?.isSubscriptionAddedToCart;
      this.isSubscriptionActiveURL = parsedAPIUrls?.isSubscriptionActive;
      this.cartURL = parsedAPIUrls?.myCart;
      this.popUpIdItemExistsInCart = parsedAPIUrls?.popUpIdItemExistsInCart;
      this.popUpIdItemExistsInLibrary = parsedAPIUrls?.popUpIdItemExistsInLibrary;
    }
    this.loggedIn =
      this.subscribeButtonContainer?.dataset?.attr?.length == 0 || this.subscribeButtonContainer?.dataset?.attr?.length == undefined ? false : true;
  },
  addEvent: function () {
    const viewMoreButton = document?.querySelector<HTMLButtonElement>('.saig-o-sbs-page-documentlist__view-more');
    const loginButton = document?.querySelector<HTMLButtonElement>('.saig-o-sbs-page-subscription-details-login-button');
    const subscribeButton = document?.querySelector<HTMLButtonElement>('.saig-o-sbs-page-subscription-details-subscribe-button');

    viewMoreButton?.addEventListener('click', this.buttonClickHandler.bind(this));
    loginButton?.addEventListener('click', this.loginClickHandler.bind(this));
    subscribeButton?.addEventListener('click', this.subscribeClickHandler.bind(this));
  },
  subscribeClickHandler: function (event: any) {
    event.preventDefault();
    event.stopPropagation();
    if (!this.loggedIn) {
      const loginWrapper = document?.querySelector<HTMLDivElement>('.saig-o-sbs-page-subscription-details-login-wrapper');
      loginWrapper?.classList.remove('display-none');
      this.subscribeButtonContainer?.classList.add('display-none');
    } else if (this.validateCheckboxes()) {
      console.log('valid');
      this.isSubscriptionAlreadAddedToCart();
    }
  },
  validateCheckboxes: function () {
    const checkboxes = document.querySelectorAll('input[type=checkbox]');
    let valid = true;
    [].forEach.call(checkboxes, (checkbox: HTMLInputElement) => {
      checkbox?.checked
        ? document?.querySelector('.saig-a-radiocheckbox__status.' + checkbox.id)?.classList.add('display-none')
        : document?.querySelector('.saig-a-radiocheckbox__status.' + checkbox.id)?.classList.remove('display-none');
      if (!checkbox?.checked) {
        valid = false;
      }
    });
    return valid;
  },
  findSelectedValue: function (inputGroupName: string) {
    const inputGroup = document?.querySelectorAll<HTMLInputElement>('input[name^=' + inputGroupName + ']');
    let returnValue = '-1';
    [].forEach.call(inputGroup, (item: HTMLInputElement) => {
      if (item.checked == true) {
        returnValue = item.value;
      }
    });
    return Number(returnValue);
  },
  readSBSData: function () {
    const subscribeButtonContainer = document?.querySelector<HTMLDivElement>('.saig-a-radiocheckbox.selected-radio');
    this.cartObj.sku = subscribeButtonContainer?.dataset?.sku || '';
    this.cartObj.showABN = this.findSelectedValue('abn-options') == 1;
    this.cartObj.showAssociate = this.findSelectedValue('organisation-options') == 1;
  },
  isSubscriptionAlreadAddedToCart: function () {
    this.readSBSData();
    const self = this;

    getIsSubscriptionAlreadAddedToCart(this.cartObj.sku, this.isSubscriptionAddedToCartURL)
      .then((response: any) => {
        if (response != null) {
          if (!response) {
            return getIsSubscriptionsActive(self.cartObj.sku, self.isSubscriptionActiveURL);
          } else {
            this.showModal(true, this.popUpIdItemExistsInCart, {}, {});
          }
        }
      })
      .then((response: any) => {
        if (response != null) {
          if (!response) {
            return postAddSubscriptionToCart(self.cartObj, self.addSubscriptionToCartURL);
          } else {
            this.showModal(true, this.popUpIdItemExistsInLibrary, {}, {});
          }
        }
      })
      .then((response: any) => {
        if (response != null) {
          const cartData = response;
          if (cartData.iFlagSuccess === 1) {
            this.postAddtoCartEventToGA(this.cartObj.sku)
            window.location.href = self.cartURL;
          }
        }
      })
      .catch((error) => {
        console.log('error calling API: ' + error);
      });
  },
   postAddtoCartEventToGA: function (sku:string) {
    try {
      const priceSpan = document?.querySelector('.saig-o-sbs-page-subscription-details-price .h3');
      const productName=document?.querySelector('.saig-a-section-header__title');
      var currentRegion = "APAC";
      const productObj = {
        event: "add_to_cart",
        region: currentRegion,
        currency: "AUD",
        value:priceSpan?parseFloat(priceSpan?.innerHTML.replace('$','')):0,
        items: [
          {
            item_id: sku,
            item_name: productName?.innerHTML,
            item_brand: "Standard Australia",
            item_variant: "Small Business Set",
            price: priceSpan?parseFloat(priceSpan?.innerHTML.replace('$','')):0,
            quantity: 1
          }
        ]
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(productObj);
    } catch {
      console.error('Error in add to cart event');
    }
  },
  loginClickHandler: function (event: any) {
    event.preventDefault();
    event.stopPropagation();
    window.redirectAfterLogin = false;
    window.dispatchEvent(new CustomEvent('openLogin'));
  },
  buttonClickHandler: function (event: any) {
    event.preventDefault();
    event.currentTarget.innerText = event.currentTarget.innerText == 'View Less' ? 'View More' : 'View Less';
    const showHideItems = document?.querySelectorAll<HTMLDivElement>('.saig-o-sbs-page-documentlist__list-item.show-hide');
    [].forEach.call(showHideItems, (itemDiv: HTMLElement) => {
      itemDiv?.classList.contains('display-none') ? itemDiv?.classList.remove('display-none') : itemDiv?.classList.add('display-none');
    });
  },
  buildCustomListener: function () {
    window.addEventListener('radioCheckboxChange', (event) => {
      const inputId = event.detail.inputId;
      const inputElement = document?.querySelector<HTMLInputElement>('#' + inputId);
      inputElement?.name == 'subscription-options' && this.radioChangeHandler(inputElement);
    });
  },
  radioChangeHandler: function (inputElement?: HTMLInputElement | null) {
    const priceSpan = document?.querySelector<HTMLInputElement>('.saig-o-sbs-page-subscription-details-price .h3');
    priceSpan && (priceSpan.innerHTML = inputElement!.value);

    const radioButtonWrapper = document?.querySelector<HTMLDivElement>(
      '.saig-o-sbs-page-subscription-details-options .saig-a-radiocheckbox.selected-radio'
    );
    radioButtonWrapper?.classList.remove('selected-radio');

    const InputButtonWrapper = inputElement?.closest('.saig-a-radiocheckbox');

    InputButtonWrapper?.classList.add('selected-radio');
  },
  showModal: function (show: boolean, popUpId?: string, confirmCallback?: any, closeCallback?: any) {
    window.dispatchEvent(
      new CustomEvent<SelectModalModel>('selectModal', { detail: { popUpId: popUpId, confirmCallback, closeCallback, selfControl: true } })
    );
  },
};

smallBusinessSet.init();

export { smallBusinessSet };
